import {ReactNode, useCallback} from 'react';
import {useFormikContext} from 'formik';
import {useTranslation} from 'react-i18next';
import {Helper} from '@tickchak/react-share/app';
import FormikModeBtn from '../../../../../../../component/formikModeBtn/FormikModeBtn';
import * as css from '../../PricingStep/PricingStep.css';
import * as headerCss from './ToggleSection.css';
import {SubscriptionFormValues} from '../../../createSubscriptionForm.types';

interface ToggledSectionProps {
    icon?: string;
    titleKey: string;
    toggleName: keyof SubscriptionFormValues;
    toggleLabelKey: string;
    fieldNames: string[];
    children: ReactNode;
    helperTitleKey?: string;
    helperContentKey?: string;
}

function ToggledSection({icon, titleKey, toggleName, toggleLabelKey, fieldNames, children, helperTitleKey, helperContentKey}: ToggledSectionProps) {
    const {t} = useTranslation('subscriptions');
    const {values, setFieldValue} = useFormikContext<SubscriptionFormValues>();
    const isActive = values[toggleName] === true;

    const handleToggleClick = useCallback(() => {
        if(isActive) {
            fieldNames.forEach(fieldName => {
                setFieldValue(fieldName, null);
            });
        }
    }, [isActive, fieldNames, setFieldValue]);

    return (
        <css.toggledSectionWrapper>
            <headerCss.toggleHeader $isActive={isActive}>
                <css.headerTitle $icon={icon}>
                    {t(titleKey)}
                    {helperContentKey && (
                        <Helper
                            title={helperTitleKey ? t(helperTitleKey) : null}
                            content={<css.helperContent>{t(helperContentKey)}</css.helperContent>}
                            size='small'
                        />
                    )}
                </css.headerTitle>
                <headerCss.toggleEndSide>
                    <headerCss.toggleLabel>{t(toggleLabelKey)}</headerCss.toggleLabel>
                    <FormikModeBtn name={toggleName as string} className={''} forwardRef={undefined} click={handleToggleClick} />
                </headerCss.toggleEndSide>
            </headerCss.toggleHeader>
            <css.section $isClose={!isActive}>
                {children}
            </css.section>
        </css.toggledSectionWrapper>
    );
}

export default ToggledSection;

